import React from "react";

const WarningIcon = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 0.833344C7.18 0.833344 0.833336 7.18001 0.833336 15C0.833336 22.82 7.18 29.1667 15 29.1667C22.82 29.1667 29.1667 22.82 29.1667 15C29.1667 7.18001 22.82 0.833344 15 0.833344ZM16.4167 22.0833H13.5833V19.25H16.4167V22.0833ZM16.4167 16.4167H13.5833V7.91668H16.4167V16.4167Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default WarningIcon;
